import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure61 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 180,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#deebf7', '#9dc3e6', '#5b9bd5'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
	    hover: {
			   enabled: true,
			   radius: 5
		   }
    }
}
}
},

exporting: {
enabled: false
},

xAxis: [{
categories: [
	     "Mundo",
	     "",
	     "América septentrional y Europa",
	     "América Latina y el Caribe",
	     "Asia occidental y África septentrional",
	     "África subsahariana",
	     "Asia central y Asia meridional",
	     "Australia y Nueva Zelandia",
	     "Asia oriental y Asia sudoriental",
	     "Oceanía (excluidas Australia y Nueva Zelandia)",
	     "",
	     "Países en desarrollo sin litoral",
	     "Pequeños Estados insulares en desarrollo",
	     "Países menos adelantados",
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
useHTML: true,
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
		format: '{value:.2f}',
style: {
	   fontWeight: 'normal',
	   color: '#999999',
	   fontSize: '12px'
   },
},
max: 2.00,
min: 0,
tickInterval: 0.20,
gridLineWidth: 2,
title: {
text: '',
style: {
	 color: Highcharts.getOptions().colors[1]
 }
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [
{
name: '2015',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
	      format: '{point.label}',
style: {
	  fontWeight: 'normal',
	  textOutline: false,
	  color: '#999999',
	  fontSize: '12px'
  }
},
data: [
       0.100,
       { y: 0 },
       0.026,
       0.076,
       0.231,
       0.429,
       0.246,
       0.578,
       0.912,
       1.627,
       { y: 0 },
       { y: 0, label: 'No aplicable' },
       0.498,
       1.244,
],
},
{
name: '2017',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
	      format: '{point.label}',
style: {
	  fontWeight: 'normal',
	  textOutline: false,
	  color: '#999999',
	  fontSize: '12px'
  }
},
data: [
       0.103,
       { y: 0 },
       0.028,
       0.096,
       0.251,
       0.505,
       0.247,
       0.566,
       0.805,
       1.609,
       { y: 0 },
       { y: 0 },
       0.507,
       1.202,
]
},
{
	name: '2019',
	      tooltip: {
		      valueSuffix: '%'
	      },
	      dataLabels: {
		      enabled: true,
	      format: '{point.label}',
		      style: {
				       fontWeight: 'normal',
				       textOutline: false,
				       color: '#999999',
				       fontSize: '12px'
			       }
	      },
	      data: [
		     0.097,
		     { y: 0 },
		     0.025,
		     0.090,
		     0.224,
		     0.381,
		     0.208,
		     0.513,
		     0.796,
		     1.542,
		     { y: 0 },
		     { y: 0 },
		     0.459,
		     0.882
		    ]
}	]
}

